﻿﻿﻿<kpi-menu (outputDownload)="downloadKpiFiltered()" (onReload)="onReload()"></kpi-menu>
<h2>{{title}} for {{defaults.tenant}}</h2>

<kpi-filter (outputFilter)="getFilteredKpisByTenant()"></kpi-filter>
<kpi-list [list]="list" [showLocalFilter]="showLocalFilter"></kpi-list>